<div class="flex justify-between items-center left-rail-section-header">
  <cla-left-rail-section-heading>
    {{ propertyCount }} {{ propertyCount === 1 ? "Property" : "Properties" }}
    <span class="mx-bl-2">|</span> {{ partyCount }}
    {{ partyCount === 1 ? "Party" : "Parties" }}
  </cla-left-rail-section-heading>
</div>
@if (isLoading) {
<ul class="skeleton-loader">
  <li>
    <div class="tree-item list-item">
      <div class="ghost-line w-16"></div>
    </div>
  </li>
  <li>
    <div class="tree-item list-item">
      <div class="ghost-line w-24"></div>
    </div>
  </li>
  <li>
    <div class="tree-item list-item">
      <div class="ghost-line w-20"></div>
    </div>
  </li>
</ul>
} @if (!isLoading) {
<ul data-pgr-id="claimPropList">
  @for (property of data; track property; let i = $index) {
  <li class="property">
    @if (property.propertyType) {
    <div
      attr.data-pgr-id="claimProp-{{ property.displayName }}-{{ property.id }}"
      class="tree-item list-item"
    >
      <span
        class="list-item-label font-extra-bold"
        [matTooltip]="property.displayName"
        [matTooltipShowDelay]="500"
        [attr.aria-hidden]="true"
      >
        {{ property.displayName }}
      </span>
      <div
        class="party-property-relations"
        [matTooltip]="property.relationsKey | cuiTooltipLineBreaks"
        [attr.aria-hidden]="true"
      >
        {{ property.relations.join(" ") }}
      </div>
      <span class="screen-reader-only">
        {{ property.displayName }} details {{ property.relationsKey.join(" ") }}
      </span>
    </div>
    } @if (!property.propertyType) {
    <div class="tree-item list-item">
      <span class="list-item-label font-extra-bold">
        {{ property.displayName }}
      </span>
    </div>
    } @if ( property.associatedPartyProperties &&
    property.associatedPartyProperties.length ) {
    <ul>
      @for (associatedParty of property.associatedPartyProperties; track
      associatedParty) {
      <li class="tree-item tree-party">
        <div class="list-item pr-0">
          <span
            class="list-item-label mr-auto"
            [matTooltip]="associatedParty.displayName"
            [matTooltipShowDelay]="500"
            [attr.aria-hidden]="true"
          >
            @if (associatedParty.hasAttorney) {
            <div class="icon">
              <mat-icon svgIcon="attorney"></mat-icon>
            </div>
            } @if ( !associatedParty.hasAttorney &&
            associatedParty.hasBeenContacted ) {
            <div class="icon">
              <mat-icon svgIcon="contacted"></mat-icon>
            </div>
            } @if ( !associatedParty.hasAttorney &&
            !associatedParty.hasBeenContacted ) {
            <div class="icon">
              <mat-icon svgIcon="contact-pending"></mat-icon>
            </div>
            }
            <div class="associated-party-label">
              {{ associatedParty.displayName }}
            </div>
          </span>
          <div
            class="party-property-relations"
            [matTooltip]="associatedParty.relationsKey | cuiTooltipLineBreaks"
            [attr.aria-hidden]="true"
          >
            {{ associatedParty.relations.join(" ") }}
          </div>
          <span class="screen-reader-only">
            {{ associatedParty.displayName }} details
            {{ associatedParty.hasAttorney ? "(Attorney)" : "" }}
            {{
              associatedParty.hasBeenContacted
                ? "(Contacted)"
                : "(Contact Pending)"
            }}
            {{ associatedParty.relationsKey.join(" ") }}
          </span>
        </div>
        <cla-tree-party-contact-card
          [partyId]="associatedParty.id"
          [propertyId]="property.id"
          [partyName]="associatedParty.displayName"
          [hasAttorney]="associatedParty.hasAttorney"
        ></cla-tree-party-contact-card>
      </li>
      }
    </ul>
    }
  </li>
  }
</ul>
}
